module.exports = __webpack_public_path__ + "static/pca-product-8513f632bb783d1fba2280e450c21b86.svg";